import { Component, Input, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { AnimationService } from '../../services/animation.service';
import { TranslatePipe } from '../../translate/pipes/translate.pipe';
import { NavigationService } from '../../services/navigation.service';
import { LoggerService } from '../../services/logger.service';

@Component({
  selector: 'app-exit-dialog',
  templateUrl: './exit-dialog.component.html',
  styleUrls: ['./exit-dialog.component.scss'],
  standalone: true
})
export class ExitDialogComponent {
  @Input() header: string;
  @Input() message: string;

  constructor(
    private alertController: AlertController,
    private animationService: AnimationService,
    private tp: TranslatePipe,
    private navigationService: NavigationService,
    private logger: LoggerService
  ) { }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: this.header,
      message: this.message,
      cssClass: 'exit-alert',
      buttons: [
        {
          text: this.tp.transform('YES'),
          role: 'confirm',
          handler: () => {
            this.logger.addLogItem('EXIT_DIALOG_CONFIRM');
            this.navigationService.navigateRootSlideInLeft('home', { replaceUrl: true });
          }
        },
        {
          text: this.tp.transform('NOPE'),
          role: 'cancel',
        }
      ],
      enterAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogAnimation(baseEl, 0.75);
      },
      leaveAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogReversedAnimation(baseEl, 0.75);
      },
      backdropDismiss: false
    });

    alert.addEventListener('ionAlertWillDismiss', async (event) => {
      if (event.detail.role === 'backdrop') {
        const alertElement = document.querySelector('.exit-alert');
        if (alertElement) {

          const animation = this.animationService.dissolveDialogReversedAnimation(alertElement as HTMLElement, 0.75);
          await animation.play();
        }
      }
    });
    const alertEl = document.querySelector('.exit-alert');
    const buttons = alertEl?.querySelectorAll('button');

    if (buttons && buttons.length >= 2) {
      buttons[0].setAttribute('data-test', 'exit-yep-button');
      buttons[1].setAttribute('data-test', 'exit-nope-button');
    }

    const popStateHandler = async (event: any) => {
      await alert.dismiss();
    };

    window.addEventListener('popstate', popStateHandler);

    alert.onDidDismiss().then(() => {
      window.removeEventListener('popstate', popStateHandler);
    });

    await alert.present();
    return alert;
  }

}
